<template>
  <el-container class="lad-search-wrapper">
    <el-main>
      <div class="type-flight">
        <el-select v-model="search.flightType">
          <el-option
            v-for="item in flightType"
            :key="item"
            :label="$t(`flights.${item}_flight`)"
            :value="item"
          >
          </el-option>
        </el-select>
        <el-select v-model="search.selectedCabins">
          <el-option
            v-for="item in selectedCabins"
            :key="item"
            :label="$t('flights.cabins.' + item)"
            :value="item"
          >
          </el-option>
        </el-select>
        <el-button plain @click="dialogPaxVisible = true"
          ><i class="fas fa-solid fa-users" /> {{ totalTickets }}
          <i class="fas fa-suitcase-rolling" />
          {{ totalBags }}</el-button
        >
        <el-dialog :visible.sync="dialogPaxVisible" class="pax-bags">
          <p>{{ $t('flights.pax_bags.passengers') }}</p
          ><p />
          <span>{{ $t('flights.pax_bags.adults') }}</span>
          <el-input-number
            v-model="paxAndBags.adults"
            :min="1"
            :max="totalTickets === 9 ? paxAndBags.adults : 9"
          ></el-input-number>
          <span>{{ $t('flights.pax_bags.children') }}</span>
          <el-input-number
            v-model="paxAndBags.children"
            :min="0"
            :max="totalTickets === 9 ? paxAndBags.children : 9"
          ></el-input-number>
          <span>{{ $t('flights.pax_bags.infants') }}</span>
          <el-input-number
            v-model="paxAndBags.infants"
            :min="0"
            :max="totalTickets === 9 ? paxAndBags.infants : 9"
          ></el-input-number>
          <p>{{ $t('flights.pax_bags.bags') }}</p
          ><p />
          <span>{{ $t('flights.pax_bags.adult_checked_baggage') }}</span>
          <el-input-number
            v-model="paxAndBags.adultHoldBag"
            :min="0"
            :max="paxAndBags.adults * 2"
          ></el-input-number>
          <span>{{ $t('flights.pax_bags.adult_cabin_baggage') }}</span>
          <el-input-number
            v-model="paxAndBags.adultHandBag"
            :min="0"
            :max="paxAndBags.adults"
          ></el-input-number>
          <span>{{ $t('flights.pax_bags.children_checked_baggage') }}</span>
          <el-input-number
            v-model="paxAndBags.childHoldBag"
            :min="0"
            :max="paxAndBags.children * 2"
            :disabled="!hasChildren"
          ></el-input-number>
          <span>{{ $t('flights.pax_bags.children_cabin_baggage') }}</span>
          <el-input-number
            v-model="paxAndBags.childHandBag"
            :min="0"
            :max="paxAndBags.children"
            :disabled="!hasChildren"
          ></el-input-number>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogPaxVisible = false">
              {{ $t('general.cancel') }}</el-button
            >
            <el-button type="primary" @click="dialogPaxVisible = false">{{
              $t('general.apply')
            }}</el-button>
          </span>
        </el-dialog>
      </div>
      <div class="flight-dates-locations">
        <el-select
          v-model="search.flyFrom"
          filterable
          remote
          :placeholder="$t('flights.from')"
          :remote-method="searchCity"
          :loading="loading"
        >
          <el-option
            v-for="item in options"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="search.flyTo"
          filterable
          remote
          :placeholder="$t('flights.to')"
          :remote-method="searchCity"
          :loading="loading"
        >
          <el-option
            v-for="item in options"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>

        <LadFilterDateRange
          class="dates"
          :value="dateFlightGo"
          :open="openGo"
          :width-sidebar="isAdvanced"
          :handle-apply="handleApply"
          @update-values="updateValuesGo"
        >
          <el-button
            slot="buttons"
            class="dates"
            plain
            :disabled="btnDisabled"
            icon="el-icon-date"
            @click="handleOpenPickerGo"
          >
            <span>{{ $t('flights.departure') }}</span>
            {{ $t('filters.date.from_to', { from: dateFrom, to: dateTo }) }}
          </el-button>
        </LadFilterDateRange>
        <LadFilterDateRange
          class="dates"
          :value="dateFlightReturn"
          :open="openReturn"
          :min-day="minDay"
          :width-sidebar="isAdvanced"
          :handle-apply="handleApply"
          @update-values="updateValuesReturn"
        >
          <el-button
            slot="buttons"
            class="dates"
            plain
            :disabled="isOneway"
            icon="el-icon-date"
            @click="handleOpenPickerReturn"
            ><span>{{ $t('flights.return') }}</span>
            {{
              $t('filters.date.from_to', {
                from: returnFrom,
                to: returnTo,
              })
            }}
          </el-button>
        </LadFilterDateRange>

        <el-button type="primary" @click="searchFlights">{{
          $t('general.search')
        }}</el-button>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { mapState } from 'vuex'
import LadFilterDateRange from '@/components/search/components/ranges/date-range'

export default {
  name: 'LadSearchFlights',
  components: { LadFilterDateRange },
  data() {
    return {
      options: [],
      value: [],
      list: [],
      loading: false,
      dateFlightGo: [this.$dayjs(), this.$dayjs().add(3, 'day')],
      dateFlightReturn: [
        this.$dayjs().add(15, 'day'),
        this.$dayjs().add(18, 'day'),
      ],
      openGo: 0,
      openReturn: 0,
      isAdvanced: false,
      btnDisabled: false,
      dialogPaxVisible: false,
      flightType: ['round', 'oneway'],
      selectedCabins: ['M', 'W', 'C', 'F'],
      paxAndBags: {
        adults: 1,
        children: null,
        infants: null,
        adultHoldBag: null,
        adultHandBag: null,
        childHoldBag: null,
        childHandBag: null,
      },
      search: {
        flyFrom: null,
        flyTo: null,
        dateFrom: this.$dayjs().format('DD/MM/YYYY'),
        dateTo: this.$dayjs().add(3, 'day').format('DD/MM/YYYY'),
        returnFrom: this.$dayjs().add(15, 'day').format('DD/MM/YYYY'),
        returnTo: this.$dayjs().add(18, 'day').format('DD/MM/YYYY'),
        nightsInDstFrom: null,
        nightsInDstTo: null,
        flightType: 'round',
        adults: null,
        children: null,
        infants: null,
        selectedCabins: 'M',
        mixWithCabins: null,
        adultHoldBag: null,
        adultHandBag: null,
        childHoldBag: null,
        childHandBag: null,
        currency: null,
        priceFrom: null,
        priceto: null,
        stopoverFrom: null,
        stopoverTo: null,
        maxStopovers: null,
        retFromDiffAirport: null,
        retToDiffAirport: null,
      },
    }
  },
  computed: {
    ...mapState('settings', ['currency']),
    totalTickets() {
      return (
        this.paxAndBags.adults +
        this.paxAndBags.children +
        this.paxAndBags.infants
      )
    },
    totalBags() {
      return (
        this.paxAndBags.adultHoldBag +
        this.paxAndBags.adultHandBag +
        this.paxAndBags.childHoldBag +
        this.paxAndBags.childHandBag
      )
    },
    isOneway() {
      return this.search.flightType === 'oneway'
    },
    dateFrom() {
      return this.$dayjs(this.dateFlightGo[0]).format('D, MMM')
    },
    dateTo() {
      return this.$dayjs(this.dateFlightGo[1]).format('D, MMM')
    },
    returnFrom() {
      return this.$dayjs(this.dateFlightReturn[0]).format('D, MMM')
    },
    returnTo() {
      return this.$dayjs(this.dateFlightReturn[1]).format('D, MMM')
    },
    hasChildren() {
      return this.paxAndBags.children >= 1
    },
    minDay() {
      return this.$dayjs(this.dateFlightGo[1]).valueOf()
    },
  },
  watch: {
    hasChildren(value) {
      if (!value)
        this.paxAndBags.childHoldBag = this.paxAndBags.childHandBag = 0
    },
    isOneway(val) {
      val
        ? (this.search.returnFrom = this.search.returnTo = null)
        : this.updateValuesReturn(this.dateFlightReturn)
    },
    'paxAndBags.adults'() {
      if (this.paxAndBags.adults * 2 < this.paxAndBags.adultHoldBag)
        this.paxAndBags.adultHoldBag = this.paxAndBags.adults * 2

      if (this.paxAndBags.adults < this.paxAndBags.adultHandBag)
        this.paxAndBags.adultHandBag = this.paxAndBags.adults
    },
    'paxAndBags.children'() {
      if (this.paxAndBags.children * 2 < this.paxAndBags.childHoldBag)
        this.paxAndBags.childHoldBag = this.paxAndBags.children * 2

      if (this.paxAndBags.children < this.paxAndBags.childHandBag)
        this.paxAndBags.childHandBag = this.paxAndBags.children
    },
  },
  methods: {
    async searchCity(query) {
      if (query.length > 2) {
        this.loading = true

        try {
          const { data, status } = await this.$axios.get(
            `/api/v1.5/kiwi/search/locations`,
            {
              params: { term: query },
            }
          )
          if (status === 'success') {
            this.options = data
          }
          this.loading = false
        } catch (error) {
          this.loading = false
          this.options = []
        }
      } else {
        this.options = []
      }
    },
    handleOpenPickerGo(event) {
      this.openGo++
    },
    handleOpenPickerReturn(event) {
      this.openReturn++
    },
    handleApply() {},
    updateValuesGo(list) {
      this.dateFlightGo = list
      this.search.dateFrom = this.$dayjs(list[0]).format('DD/MM/YYYY')
      this.search.dateTo = this.$dayjs(list[1]).format('DD/MM/YYYY')
    },
    updateValuesReturn(list) {
      this.dateFlightReturn = list
      this.search.returnFrom = this.$dayjs(list[0]).format('DD/MM/YYYY')
      this.search.returnTo = this.$dayjs(list[1]).format('DD/MM/YYYY')
    },
    async searchFlights() {
      this.$emit('loading', true)

      for (const [key, value] of Object.entries(this.paxAndBags)) {
        this.search[key] = value > 0 ? value : null
      }
      this.search.currency = this.currency
      await this.$store.dispatch('kiwi/getFlights', this.search)
      this.$emit('loading', false)
    },
    async searchFlight() {
      await this.$store.dispatch('kiwi/getFlight', this.search)
    },
  },
}
</script>

<style lang="scss">
.lad-search-wrapper {
  margin: 0;

  .type-flight {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 8px;
    .el-select {
      width: 124px;
    }

    .el-dialog__body {
      margin: 0;
      padding: 20px;
      margin-top: 10px;
      display: grid;
      grid-template-columns: 60% 40%;
      grid-gap: 5px;
      grid-auto-rows: auto;
      grid-template-rows: auto;

      .el-input-number--medium {
        width: auto;
        justify-self: end;
      }
    }
    .dialog-footer {
      .el-button {
        margin-top: 10px;
        margin-bottom: 10px;
        margin-right: 20px;
      }
    }
  }

  .flight-dates-locations {
    margin-top: 10px;
    display: grid;
    grid-template-columns: repeat(5, auto);
    grid-gap: 10px;
    grid-auto-rows: auto;
  }

  @media screen and (max-width: 850px) {
    .flight-dates-locations {
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 10px;
      grid-auto-rows: auto;

      .dates {
        width: 100%;
        text-align: initial;
      }
    }
  }
}
</style>
